import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Slider from "../Slider";
import CustomModal from "./CustomModal";
import { investCampaign } from "../../redux/actions/web3Actions";
import { useDispatch, useSelector } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import Snackbar from "../Misc/Snackbar.js";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "4rem",
    background: "#FFFFFF",
    overflow: "scroll",
    overflowX: "hidden",
    boxShadow: "0px 4px 12px rgba(34, 43, 69, 0.06)",
    borderRadius: "8px",
    height: "50rem",
    width: "70rem",
  },

  modalHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "3rem",
  },

  poolLabel: {
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.1rem",
    marginRight: "1.6rem",
  },
  bold: {
    fontWeight: "700",
  },
  bold2: {
    fontWeight: "700",
    marginLeft: "1rem",
  },
  dot: {
    height: "6px",
    width: "6px",
    backgroundColor: "black",
    borderRadius: "100%",
    marginRight: "5px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  flex2: {
    display: "flex",
    // alignItems: "center",
  },

  poolLabelValue: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2.1rem",
  },

  poolDetailRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.6rem",
  },

  poolDetailCol: {
    display: "flex",

    flexDirection: "column",
    marginBottom: "2.4rem",
  },

  poolDetailColValue: {
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
  },
  poolDetailColValueBold: {
    fontWeight: "600",
    fontSize: "1.8rem",
    lineHeight: "2.4rem",
  },
  poolDetailsBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  poolDetailsAround: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
  btn: {
    fontWeight: "600",
    width: "13rem",
    fontSize: "1.4rem",
  },
}));

const ProjectDetailsModal = ({ showModal, setShowModal, modalData }) => {
  const classes = useStyles();
  const history = useHistory();
  const [youtube, setYoutube] = useState(false);
  const [twitter, setTwitter] = useState(false);
  const dispatch = useDispatch();
  const web3Context = useWeb3React();
  const [open, setOpen] = React.useState(false);
  const [vestingRatio, setVestingRatio] = React.useState(0);

  const [tiktok, setTiktok] = useState(false);
  const [sliderValue, setSliderValue] = useState(40);
  // console.log("SLIDER VALUE======", sliderValue);

  const [instagram, setInstagram] = useState(false);
  const isUser = useSelector((state) => state.ui.isUser);
  // const errorData = useSelector((state) => state.ui.errorData);

  console.log("modalData ===> ", modalData);
  // console.log("errorData ===> ", errorData);

  useEffect(() => {
    if (modalData?.platforms[0]) {
      if (modalData.platforms[0][1].followers) {
        setTwitter(true);

        console.log("TWITTER ===> ", twitter);
      }
      if (modalData.platforms[0][2].followers) {
        setYoutube(true);

        console.log("youtube ===> ", youtube);
      }
      if (modalData.platforms[0][3].followers) {
        setTiktok(true);
        console.log("tiktok ===> ", tiktok);
      }
      if (modalData.platforms[0][4].followers) {
        setInstagram(true);
        console.log("instagram ===> ", instagram);
      }
    }
  }, []);
  useEffect(() => {
    if (modalData?.projectId.tokenNomicId)
      setVestingRatio(
        (100 - modalData?.projectId.tokenNomicId?.tgeRelease) /
          parseFloat(modalData?.projectId.tokenNomicId?.vesting?.value)
      );
  }, [modalData]);
  // console.log("SLIDER VALUE==", sliderValue);
  const investInCampaign = () => {
    dispatch(
      investCampaign(
        modalData.budget,
        modalData.totalFollowersRequired,
        web3Context?.account,

        {
          projectId: modalData.projectId,
          kolId: isUser.kol._id,
          campaignId: modalData._id,
          invested: parseFloat(sliderValue),
          workOutstanding: 100,
          tokenAmount: parseFloat(modalData.preSaleTokenPrice),
          tokenOutstanding: parseFloat(sliderValue),
          timestamp: Date.now(),
        }
        // callbackFunction
      )
    );
    setOpen(true);
    setShowModal(false);
  };

  return (
    <CustomModal showModal={showModal} setShowModal={setShowModal}>
      {/* <Snackbar open={open} setOpen={setOpen} /> */}
      <Box className={classes.container}>
        <Typography className={classes.modalHeading}>
          Project Details
        </Typography>

        <Box>
          <Box className={classes.poolDetailRow}>
            <Typography className={classes.poolLabel}>
              Min KOL Ranking:
            </Typography>
            <Typography className={classes.poolLabelValue}>
              {modalData.minimumKOLRanking} Rating
            </Typography>
          </Box>
          <Box className={classes.poolDetailRow}>
            <Typography className={classes.poolLabel}>
              Pre-Sale Token Price:
            </Typography>
            <Typography className={classes.poolLabelValue}>
              <span className={classes.bold}>
                {modalData.preSaleTokenPrice}
              </span>{" "}
              USDT
            </Typography>
          </Box>
          <Box className={classes.poolDetailRow}>
            <Typography className={classes.poolLabel}>
              Available Allocation:
            </Typography>
            <Typography className={classes.poolLabelValue}>
              <span className={classes.bold}>
                {parseInt(modalData?.budget) - modalData?.investmentFilled}
              </span>{" "}
              USDT (
              {parseInt(
                (parseInt(modalData?.budget) - modalData?.investmentFilled) /
                  modalData.preSaleTokenPrice
              )}{" "}
              Tokens )
            </Typography>
          </Box>
          {/* {console.log(
            "hiiiiiiiii",
            parseInt(modalData?.budget) - modalData?.investFilled
          )} */}
          <Box className={classes.poolDetailCol}>
            <Typography
              className={classes.poolLabel}
              style={{ marginBottom: "1.6rem" }}
            >
              Platforms
            </Typography>
            <Box className={classes.poolDetailsBetween}>
              <Box className={classes.flex}>
                {youtube && (
                  <>
                    <Box className={classes.dot}></Box>
                    <Typography className={classes.poolDetailColValue}>
                      Youtube
                    </Typography>
                  </>
                )}
              </Box>

              <Box className={classes.flex}>
                {twitter && (
                  <>
                    <Box className={classes.dot}></Box>
                    <Typography className={classes.poolDetailColValue}>
                      Twitter
                    </Typography>
                  </>
                )}
              </Box>
              <Box className={classes.flex}>
                {tiktok && (
                  <>
                    <Box className={classes.dot}></Box>
                    <Typography className={classes.poolDetailColValue}>
                      TikTok
                    </Typography>
                  </>
                )}
              </Box>
              <Box className={classes.flex}>
                {instagram && (
                  <>
                    <Box className={classes.dot}></Box>
                    <Typography className={classes.poolDetailColValue}>
                      Instagram
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Box>
          <Box className={classes.poolDetailCol}>
            <Typography
              className={classes.poolLabelValue}
              style={{ marginBottom: "1.6rem" }}
            >
              Followers per platform (%)
            </Typography>
            <Box className={classes.poolDetailsBetween}>
              {youtube && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData.platforms[0][1].followers}%
                </Typography>
              )}
              {twitter && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData.platforms[0][2].followers}%
                </Typography>
              )}
              {tiktok && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData.platforms[0][3].followers}%
                </Typography>
              )}
              {instagram && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData.platforms[0][4].followers}%
                </Typography>
              )}
            </Box>
          </Box>
          <Box className={classes.poolDetailCol}>
            <Typography
              className={classes.poolLabelValue}
              style={{ marginBottom: "1.6rem" }}
            >
              Posts per platform
            </Typography>
            <Box className={classes.poolDetailsBetween}>
              {youtube && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData?.platforms[0][1].posts}
                </Typography>
              )}{" "}
              {twitter && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData?.platforms[0][1].posts}
                </Typography>
              )}{" "}
              {tiktok && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData?.platforms[0][1].posts}
                </Typography>
              )}{" "}
              {instagram && (
                <Typography className={classes.poolDetailColValueBold}>
                  {modalData?.platforms[0][1].posts}
                </Typography>
              )}
            </Box>
          </Box>

          <Box className={classes.poolDetailCol}>
            <Typography
              className={classes.poolLabel}
              style={{ marginBottom: "1.6rem" }}
            >
              Marketing Date Range
            </Typography>
            <Box className={classes.flex2}>
              <Typography
                className={classes.poolLabelValue}
                style={{ marginBottom: "0 0 1.6rem 6rem" }}
              >
                From:{" "}
                <span className={classes.bold2}>
                  {modalData.search.start_date}
                </span>
              </Typography>
              <Typography
                className={classes.poolLabelValue}
                style={{ margin: "0 0 1.6rem 6rem" }}
              >
                To:{" "}
                <span className={classes.bold2}>
                  {" "}
                  {modalData.search.end_date}{" "}
                </span>
              </Typography>
            </Box>
          </Box>

          <Box className={classes.poolDetailCol}>
            <Typography
              className={classes.poolLabel}
              style={{ marginBottom: "1.6rem" }}
            >
              Vesting
            </Typography>
            <Box className={classes.flex2}>
              <Typography
                className={classes.poolLabelValue}
                style={{ marginBottom: "0 0 1.6rem 6rem" }}
              >
                {modalData?.projectId.tokenNomicId?.vesting?.duration}:{" "}
                <span className={classes.bold2}>
                  {modalData?.projectId.tokenNomicId?.vesting?.value}
                </span>
                <span> ({vestingRatio.toFixed(2)}% in each duration)</span>
              </Typography>
              <Typography
                className={classes.poolLabelValue}
                style={{ margin: "0 0 1.6rem 6rem" }}
              >
                TGE:{" "}
                <span className={classes.bold2}>
                  {" "}
                  {modalData?.projectId.tokenNomicId?.tgeRelease}%
                </span>
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography style={{ marginBottom: "1.6rem", display: "flex" }}>
              <Typography className={classes.poolLabel}>
                Please Select Amount to Invest:
              </Typography>
              <Slider
                value={sliderValue}
                setValue={setSliderValue}
                maxValue={
                  parseInt(modalData?.budget) - modalData?.investmentFilled
                }
              />
            </Typography>
          </Box>
          <Button
            // onClick={() => history.push("/managefunds")}
            onClick={() => investInCampaign()}
            className={classes.btn}
          >
            <Typography className={classes.poolLabelValue}>Invest</Typography>
          </Button>
        </Box>
      </Box>
    </CustomModal>
  );
};

export default ProjectDetailsModal;
